<template>
  <div class="daily-tarot-base section">
    <div class="tarot-canvas">
      <div class="loading load"></div>
      <div class="field"><div class="inner"><div class="cards"></div></div></div>
      <div class="btn-start-wrap">
        <div class="btn-start hide" @click="onBtnElmClick"><span class="btn-face">{{ startBtnFace }}</span></div>
      </div>
      <div class="mess"><span>1枚選択してください</span></div>
    </div>

    <div class="lp-desktopSampleView result-view" :data-visible="isModalVisible">
      <div class="lp-desktopSampleView__close" @click="closeModal">
        <span></span>
        <span></span>
      </div>
      <video
        class="lp-desktopSampleView__video -normal"
        controls
        playsinline
        controlslist="nodownload"
        @click.prevent = "() => false"
        @ended="closeModal"
      ></video>
      <div class="background" @click="closeModal"></div>
    </div>
  </div>
</template>

<script>

const START_BTN_FACE = {
  initial: 'タロットを引く',
  again: 'もう一度タロットを引く'
}

export default {
  name: "DailyTarot",
  props: {
    userProfile: {
      type: Object,
      default(){
        return {}
      }
    }
  },
  data() {
    return {
      loadCnt: 0,
      startBtnFace: START_BTN_FACE.initial,
      resources: {
        backside: { url: '/static/img/toppage/daily_tarot/tarot-omote-cat.png' },
        liam: { url: '/static/img/toppage/daily_tarot/liam.png' },
        fukidashi: { url: '/static/img/toppage/daily_tarot/fukidashi.png' },
        card1: { url: '/static/img/toppage/daily_tarot/card1.png' },
        card2: { url: '/static/img/toppage/daily_tarot/card2.png' },
        card3: { url: '/static/img/toppage/daily_tarot/card3.png' }
      },
      resultNum: 78,
      shuffleNum: 30,
      state: 0,
      isInit: false,
      baseElm: null,
      loading: null,
      btnElm: null,
      whiteCover: null,
      blankCardList: [],
      whiteCard: null,
      cards: null,
      messElm: null,
      liam: null,
      fukidashi: null,
      card1: null,
      card2: null,
      card3: null,
      defVideoVol: 1,
      videoplayer: null,
      isModalVisible: false,
      cardIntv: 100
    }
  },
  mounted() {
    this.loadResources()
  },
  methods: {
    loadResources() {
      this.loadCnt = 0
      for(let key in this.resources) {
        const img = document.createElement('img')
        const tgtRsc =this.resources[key]
        img.src = tgtRsc.url
        img.addEventListener('load', () => {
          if(++this.loadCnt >= Object.keys(this.resources).length) this.initialize()
        })
      }
    },
    initialize() {
      if(!this.isInit) {
        this.state = 0
        this.baseElm = this.$el.querySelector('.field .inner')
        this.btnElm = this.$el.querySelector('.btn-start')
        this.messElm = this.$el.querySelector('.mess')
        this.loading = this.$el.querySelector('.loading')
        this.loading.style.display = 'block'
        this.loading.classList.add('load')

        this.whiteCover = document.createElement('div')
        this.whiteCover.classList.add('white-cover')
        this.videoplayer = this.$el.querySelector('video')

        const blankimg = document.createElement('img')
        blankimg.src = this.resources.backside.url


        this.cards = this.baseElm.querySelector('.cards')
        this.baseElm.appendChild(this.cards)

        for( let i = 0; i < this.shuffleNum; i++ ){
          const card = document.createElement('img')
          this.blankCardList.push(card)
          this.cards.appendChild(card)
          card.classList.add('card')
          card.src = blankimg.src
        }

        this.liam = document.createElement('img')
        this.liam.classList.add('liam')
        this.liam.src = this.resources.liam.url

        this.fukidashi = document.createElement('img')
        this.fukidashi.classList.add('fukidashi')
        this.fukidashi.src = this.resources.fukidashi.url

        this.card1 = document.createElement('img')
        this.card1.classList.add('card1', 'top-card')
        this.card1.src = this.resources.card1.url

        this.card2 = document.createElement('img')
        this.card2.classList.add('card2', 'top-card')
        this.card2.src = this.resources.card2.url

        this.card3 = document.createElement('img')
        this.card3.classList.add('card3', 'top-card')
        this.card3.src = this.resources.card3.url

        this.whiteCard = document.createElement('span')
        this.whiteCard.classList.add('card', 'white-card')
        this.baseElm.appendChild(this.whiteCard)
        this.baseElm.appendChild(this.whiteCover)
        this.baseElm.appendChild(this.liam)
        this.baseElm.appendChild(this.fukidashi)
        this.baseElm.appendChild(this.card1)
        this.baseElm.appendChild(this.card2)
        this.baseElm.appendChild(this.card3)
        this.loading.addEventListener('transitionend', this.animSeq)
        setTimeout(() => this.loading.classList.remove('load'), 100)
        this.isInit = true
      }
    },
    onBtnElmClick(e) {
      const up = this.userProfile
      if(!!up && !!up.subscription
        && !!up.subscription.status
        && parseInt(up.subscription.status) !== 2
      ) {
        gtag('event', 'click', {
          'event_category': 'TV-top-tarot',
          // 'event_label': tagId
        })
        this.videoplayer.src = this.getVideoUrl()
        this.defVideoVol = this.videoplayer.volume
        this.videoplayer.volume = 0
        this.videoplayer.play()
          .then(
            () => {
              this.videoplayer.pause()
              this.videoplayer.currentTime = 0
            }
          )
        this.animSeq()
      } else {
        location.href = '/error/suspension'
      }
    },
    animSeq(e) {
      let posX, posY, rad, dist, deg
      const clist = this.blankCardList
      const lastCard = clist[clist.length - 1]
      const last2Card = clist[clist.length - 2]
      const last3Card = clist[clist.length - 3]
      const whiteCard = this.whiteCard
      const whiteCover = this.whiteCover

      switch (this.state) {
        case 0: // カードばらかす
          this.loading.style.display = 'none'
          this.loading.removeEventListener('transitionend', this.animSeq)
          for( let item of  clist){
            item.style.transitionDuration = '400ms'
            setTimeout(() => {
              rad = Math.random() * 6.28
              dist = Math.random() * this.baseElm.clientWidth / 2
              deg = Math.random() * 360
              posX = Math.cos(rad) * dist
              posY = -Math.sin(rad) * dist
              item.style.transform = `rotate(${deg}deg) translate(${posX}px,${posY}px)`
            }, 0)
          }
          lastCard.addEventListener('transitionend', this.animSeq)
          this.state++
          break

        case 1: //引き待ちポーズ
          this.liam.classList.add('open')
          this.cards.classList.add('open')
          this.card1.classList.add('open')
          this.card2.classList.add('open')
          this.card3.classList.add('open')
          this.fukidashi.classList.add('open')
          this.btnElm.classList.remove('hide')
          this.state++
          break
        case 2: //シャッフルスタート
          this.liam.style.transition = 'all 200ms ease-out 0s'
          this.card1.classList.remove('open')
          this.card2.classList.remove('open')
          this.card3.classList.remove('open')
          this.fukidashi.classList.remove('open')
          this.card3.addEventListener('transitionend', this.animSeq)
          /*
           */
          this.state++
          break

        case 3: //飾りカードクローズ完了
          this.card3.removeEventListener('transitionend', this.animSeq)
          this.liam.addEventListener('transitionend', this.animSeq)
          this.liam.classList.remove('open')
          this.state++
          break

        case 4: //リアムクローズ完了
          this.liam.style.transition = 'all 700ms ease-out 200ms'
          this.liam.removeEventListener('transitionend', this.animSeq)
          this.cards.classList.remove('open')
          this.btnElm.classList.add('hide')
          for( let item of  clist ){
            item.style.transform = `rotate(0) translate(0,0)`
          }
          this.state++
          break

        case 5: //集合完了 -> 再ばらかし
          for( let [ index, item ] of  clist.entries() ){
            item.style.transitionDuration = '1200ms'
            setTimeout(() => {
              rad = Math.random() * 6.28
              dist = this.baseElm.clientWidth * 0.8
              deg = Math.random() * 360
              posX = Math.cos(rad) * dist
              posY = Math.sin(rad) * dist
              item.style.transform = `translate3d(${posX}px, ${posY}px, ${index * 100}px) rotate3d(0,0.5,1,${Math.random() * 180 + 90}deg)`
            }, 100)
          }
          this.state++
          break

        case 6: //再ばらかし完了 -> 再集合
          let tgtPos
          this.messElm.style.display = 'block'
          for( let [ index, item ] of  clist.entries() ){
            item.style.transitionDuration = '600ms'
            setTimeout(() => {
              if(index % 3 === 0) {
                tgtPos = -this.cardIntv
              } else if (index % 3 === 2) {
                tgtPos = this.cardIntv
              } else {
                tgtPos = 0
              }
              item.style.transform = `rotate3d(0,0,1,0) translate3d(${tgtPos}px, 0, 0)`
            }, 50 + (index * 60))
          }
          this.state++
          break

        case 7: //再集合完了 -> 1枚開く
          last3Card.style.transition = 'unset'
          last2Card.style.transition = 'unset'
          lastCard.style.transition = 'unset'

          last3Card.dataset.sel = 3
          last2Card.dataset.sel = 2
          lastCard.dataset.sel = 1

          setTimeout(() => {
            last3Card.classList.add('animKira')
          }, 0)
          setTimeout(() => last2Card.classList.add('animKira'), 100)
          setTimeout(() => lastCard.classList.add('animKira'), 200)

          lastCard.removeEventListener('transitionend', this.animSeq)
          lastCard.addEventListener('animationend', this.animSeq)
          this.state++
          break

        case 8:
          lastCard.removeEventListener('animationend', this.animSeq)
          last3Card.classList.remove('animKira')
          last2Card.classList.remove('animKira')
          lastCard.classList.remove('animKira')

          this.messElm.classList.add('open')
          last3Card.addEventListener('click', this.onCardSelect)
          last2Card.addEventListener('click', this.onCardSelect)
          lastCard.addEventListener('click', this.onCardSelect)
          break

        case 9:
          last3Card.removeEventListener('transitionend', this.animSeq)
          last2Card.removeEventListener('transitionend', this.animSeq)
          lastCard.removeEventListener('transitionend', this.animSeq)
          setTimeout(() => {
            last3Card.style.opacity = 0
            last2Card.style.opacity = 0
            lastCard.style.opacity = 0
            this.state++
            setTimeout(()=>{
              this.animSeq()
            },0)
          }, 0)
          break

        case 10: //1枚90度回転完了 -> 白カード回転
          whiteCard.style.transitionDuration = '600ms'
          whiteCard.style.visibility = 'visible'
          whiteCard.addEventListener('transitionend', this.animSeq)
          whiteCover.style.display = 'block'
          setTimeout(()=>{
            whiteCard.style.transform = `translate3d(0px, 0px, 400px) rotate3d(0, 1, 0, 180deg)`
            whiteCover.classList.add('open')
            last3Card.style.transform = `rotate3d(0,0,1,0) translate3d(0, 0, 0)`
            last2Card.style.transform = `rotate3d(0,0,1,0) translate3d(0, 0, 0)`
            lastCard.style.transform = `rotate3d(0,0,1,0) translate3d(0, 0, 0)`
          },100)
          this.state++
          break

        case 11: // 白カード回転完了
          whiteCard.removeEventListener('transitionend', this.animSeq)
          for( let [ index, item ] of  clist.entries() ){
            item.style.transform = 'translate(0,0)'
            item.style.opacity = 1
            item.style.zIndex = 100
            item.style.transitionDuration = '500ms'
          }

          setTimeout(()=>{
            whiteCard.style.visibility = 'hidden'
          }, 100)
          this.isModalVisible = true
          this.videoplayer.volume = this.defVideoVol
          setTimeout(() => this.videoplayer.play(), 0 )
          this.state++
          break

        case 12: //白カバー消す
          whiteCover.classList.remove('open')
          whiteCover.addEventListener('transitionend', this.animSeq)
          this.startBtnFace = START_BTN_FACE.again
          this.state++
          break

        case 13: //白カバー消す完了 -> 初期状態へ
          whiteCover.removeEventListener('transitionend', this.animSeq)
          whiteCover.style.display = 'none'
          this.state = 0
          setTimeout(this.animSeq, 200)
      }
    },
    onCardSelect(e) {
      const clist = this.blankCardList
      const lastCard = clist[clist.length - 1]
      const last2Card = clist[clist.length - 2]
      const last3Card = clist[clist.length - 3]
      last3Card.removeEventListener('click', this.onCardSelect)
      last2Card.removeEventListener('click', this.onCardSelect)
      lastCard.removeEventListener('click', this.onCardSelect)

      const selectedCard = e.target
      const whiteCard = this.whiteCard
      const sel = parseInt(e.target.dataset.sel)
      let intv = sel === 1 ? this.cardIntv : sel === 3 ? -this.cardIntv : 0

      selectedCard.style.transitionDuration = '0'
      selectedCard.style.zIndex = 2000
      whiteCard.style.transitionDuration = '0'
      whiteCard.style.transform = `translate3d(${intv}px, 0, 0)`

      this.messElm.classList.remove('open')

      setTimeout(()=>{
        selectedCard.addEventListener('transitionend', this.animSeq)
        last3Card.style.transition = 'transform 800ms ease-out 0s'
        last2Card.style.transition = 'transform 800ms ease-out 0s'
        lastCard.style.transition = 'transform 800ms ease-out 0s'
        whiteCard.style.transform = `translate3d(0px, 0px, 300px) rotate3d(0, 1, 0, 90deg)`
        selectedCard.style.transform = `translate3d(0px, 0px, 300px) rotate3d(0, 1, 0, 90deg)`
      },100)
      this.state++
    },
    getVideoUrl() {
      const baseUrl = 'https://uranaitv-town-prd.s3-ap-northeast-1.amazonaws.com'
      const targetNum = Math.ceil(Math.random() * this.resultNum)
      return `${baseUrl}/daily/matatabi/movie/Neko_Honpen_card${('00' + targetNum).slice(-2)}.mp4`
    },
    closeModal(e) {
      this.isModalVisible = false
      this.videoplayer.pause()
      this.animSeq()
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../../sass/commons/commonVariables.scss";
.daily-tarot-base {
  width: 100%;
  padding: 0 20px 20px;
  max-width: 580px;
  margin: auto;
  .tarot-canvas {
    width: 100%;
    padding-top: calc(20px + 20px + 60%);
    position: relative;
    overflow: hidden;
    border-radius: 10px;
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
    background: $col_white_translucent;

    .mess {
      position: absolute;
      display: none;
      font-size: 1.2em;
      font-weight: bold;
      bottom: 18px;
      left: 0;
      text-align: center;
      width: 100%;
      opacity: 0;
      transition: opacity 1000ms ease-out 0s;
      &.open {
        opacity: 1;
      }
      span {
        animation: anim-mess-twinkle 1000ms linear 0s infinite alternate;
      }
    }

    .loading {
      width: 100%;
      height: 100%;
      display: block;
      position: absolute;
      z-index: 800;
      top: 0;
      left: 0;
      background: url('/static/img/common/loading.svg') no-repeat center center rgba(255,255,255,0.9);
      background-size: 80px 80px;
      transition: opacity 500ms ease-out 0s;
      opacity: 0;
      &.load {
        opacity: 1;
      }
    }
    /deep/ .white-cover {
      width: 100%;
      height: 100%;
      background: white;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 500;
      transition: opacity 800ms ease-out 0s;
      display: none;
      opacity: 0;
      &.open {
        opacity: 1;
      }
    }
    /deep/ .card {
      $defCardW: 75px;
      display: block;
      width: $defCardW;
      height: $defCardW * 1.8181;
      border-radius: 0;
      box-shadow: none;
      position: absolute;
      padding: 0;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      transition: all 800ms ease-out 0s;
      z-index: 100;
      &.white-card {
        background: #fcfcfc;
        border-radius: 3px;
        visibility: hidden;
      }
      &.current {
        visibility: hidden;
        transform: rotate3d(0,1,0,90deg);
        &.open {
          transform: translate3d(0, 0, 100px) rotate3d(0,1,0,0deg) scale(2.0);
          filter: drop-shadow(2px 2px 3px rgba(0,0,0,0.15));
        }
      }
      &.brightness {
        opacity: 0.5;
      }
      &.open {
        transform: rotate3d(0,1,0,90deg) scale(2.0);
      }
      &.animKira {
        animation: anim-card-kira 800ms ease-out 0s;
      }
    }

    /deep/ .liam {
      width: 51%;
      position: absolute;
      bottom: 19%;
      left: 0;
      right: 0;
      margin: auto;
      z-index: 200;
      opacity: 0;
      pointer-events: none;
      transition: all 700ms ease-out 200ms;
      transform: scale(1.5, 1);
      filter: brightness(10) drop-shadow(0 0 5px rgba(255,240,255,1));
      &.open {
        opacity: 1;
        transform: scale(1, 1);
        filter: brightness(1) drop-shadow(0 0 0 rgba(255,255,255,0));
      }
    }
    /deep/ .fukidashi {
      width: 36%;
      position: absolute;
      top: calc(50% - 25%);
      left: calc(50% - 18%);
      margin: -13% 0 0 -27.5%;
      z-index: 200;
      opacity: 0;
      transition: all 400ms ease-out 1000ms;
      transform: scale(1.5, 1.5) translate(-15px, 0) rotate(-20deg);
      pointer-events: none;
      &.open {
        opacity: 1;
        transform: scale(1, 1) translate(0, 0) rotate(0);
      }
    }
    /deep/ .top-card {
      width: 11.2%;
      position: absolute;
      left: calc(50% - 5.5%);
      z-index: 200;
      opacity: 0;
      pointer-events: none;
      transform-origin: center bottom;
      &.card1 {
        bottom: 25%;
        margin-left: 17%;
        transition: all 300ms ease-out 600ms;
        transform: rotate(-30deg);
        &.open {
          opacity: 1;
          transform: rotate(-15deg);
        }
      }
      &.card2 {
        bottom: 28%;
        margin-left: 20%;
        transition: all 300ms ease-out 700ms;
        transform: rotate(-10deg);
        &.open {
          opacity: 1;
          transform: rotate(5deg);
        }
      }
      &.card3 {
        bottom: 23%;
        margin-left: 23.6%;
        transition: all 300ms ease-out 800ms;
        transform: rotate(10deg);
        &.open {
          opacity: 1;
          transform: rotate(25deg);
        }
      }
    }


    .field {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      .inner {
        width: 100%;
        height: 100%;
        position: relative;
        .cards {
          width: 100%;
          height: 100%;
          transition: all 300ms ease-out 0s;
          opacity: 1;
          filter: blur(0);
          transform-style: preserve-3d;
          perspective: 1000px;
          &.open {
            opacity: 0.5;
            filter: blur(1px);

          }
        }
      }
    }
    &::after {
      display: none;
      content: "今日の運勢";
      font-weight: bold;
      color: $col_base_black;
      position: absolute;
      left: 12px;
      top: 9px;
    }
    .btn-start-wrap {
      display: inline-block;
      //width: calc(100% - 48px);
      //height: 44px;
      //background: $col_def_gradient;
      position: absolute;
      cursor: pointer;
      opacity: 1;
      transition: opacity 500ms ease-out 0s;
      bottom: 13.3%;
      left: 0;
      right: 0;
      margin: auto;
      z-index: 400;
      text-align: center;
      .btn-start {
        min-width: 270px;
        display: inline-block;
        font-weight: bold;
        font-size: 14px;
        color: white;
        padding: 13px 32px;
        border-radius: 32px;
        cursor: pointer;
        position: relative;
        z-index: 1;
        background: $col_def_gradient;
        box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
        &.hide {
          opacity: 0;
          pointer-events: none;
        }

        &::before {
          position: absolute;
          top: 0;
          left: 0;
          z-index: -1;
          box-sizing: border-box;
          border-radius: 2em;
          padding: 2px;
          width: 100%;
          height: 100%;
          background: #fff;
          background-clip: content-box;
          content: "";
        }

        .btn-face {
          color: $col_temp_key1;
          background: $col_def_gradient;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }

      /*
      display: inline-block;
      width: calc(100% - 48px);
      height: 44px;
      background: $col_def_gradient;
      position: absolute;
      cursor: pointer;
      opacity: 1;
      transition: opacity 500ms ease-out 0s;
      bottom: 13.3%;
      left: 0;
      right: 0;
      margin: auto;
      border-radius: 30px;
      color: white;
      font-size: 1.2em;
      font-weight: bold;
      line-height: 1;
      z-index: 400;
      span {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        animation: anim-btn-twinkle 1400ms linear 0s infinite alternate;
      }
      */
    }
  }
  video {
    position: relative;
    z-index: 1200;
  }
  .lp-desktopSampleView {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.9);
    z-index: 1200;
    align-items: center;
    justify-content: center;
    display: none;
    padding: 24px;
  }
  .lp-desktopSampleView[data-visible='true'] {
    display: flex;
  }

  .lp-desktopSampleView__close {
    width: 32px;
    height: 32px;
    position: absolute;
    top: 60px;
    right: 8px;
    cursor: pointer;
    span {
      display: block;
      position: absolute;
      top: 0;
      width: 28px;
      height: 4px;
      border-radius: 2px;
      background: #555;
      &:nth-child(1) {
        transform: rotate(45deg);
        transform-origin: left top;
        right: 0;
      }
      &:nth-child(2) {
        transform: rotate(-45deg);
        transform-origin: right top;
        right: 11px
      }
    }
  }

  .lp-desktopSampleView__video {
    max-height: 390px;
    max-width: 100%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    @media screen and (min-width: 375px) {
      max-height: 430px;
    }
    @media screen and (min-width: 580px) {
      max-height: 650px;
    }
  }
  .lp-desktopSampleView__close {
    z-index: 1200;
  }
  .background {
    width: 100%;
    height: 100%;
    background: transparent;
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
  }
}
@keyframes anim-btn-twinkle {
  0% {
    opacity: 1;
    /*text-shadow: 0 0 10px rgba(255,255,255,0.8);*/
  }
  100% {
    opacity: 0.7;
    /*text-shadow: 0 0 10px rgba(255,255,255,0);*/
  }
}
@keyframes anim-mess-twinkle {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
}
@keyframes anim-card-kira {
  0% {
    filter: brightness(1.0);
  }
  20% {
    filter: brightness(1.4);
  }
  100% {
    filter: brightness(1.0);
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Toppage/section/DailyTarot.vue